import { type___locale___language } from "./types.locale";
import { type___geo___lngLat } from "./types.types";

/* 
 * 
 * 
 * 
 * 								T Y P E S   I F R A M E
 * 
 * 
 * 
 */

export type type___iframe___configParams = {
	
	map_center: type___geo___lngLat | null,
	map_zoom: number | null,

	locale: type___locale___language | null,
	display_user_position: boolean,

	target: 'all' | 'poi' | 'poi_categories' | 'events' | 'event_categories' | null,
	params: string[] | null,
	from: string | null,

};

export const type___configParams___standards: type___iframe___configParams = {
	
	map_center: null,
	map_zoom: 18,

	locale: 'it_it',
	display_user_position: false,

	target: 'all',
	params: null,
	from: null,

};